import { Box, Button, Heading, Link, Text } from '@chakra-ui/react';
import firebase from 'firebase';
import React from 'react';
import { PageContainer } from '../../../components/container/PageContainer';
import { FirebaseConfig } from '../../../types/types';

interface InactiveProps {
  currentUser: firebase.User;
  config: FirebaseConfig;
}

export const Inactive: React.FC<InactiveProps> = ({ currentUser, config }) => (
  <PageContainer isHeader>
    <Heading size="md">Du bist inaktiv</Heading>
    <Text mt={3} mb={6}>
      Du scheinst nicht mehr als aktives Mitglied geführt zu werden. Dies kann
      folgende Gründe haben:
    </Text>
    <Box w="full" boxShadow="md" borderRadius="xl" p={4} mb={6}>
      <Text>
        Du warst ein aktives Mitglied, bist es aber nicht mehr, weil dein
        Vertrag ausgelaufen ist.
      </Text>
      <Button
        target="_blank"
        as={Link}
        mt={3}
        colorScheme="brand"
        href={config.contactUrl}
      >
        Ich möchte wieder einen Vertrag
      </Button>
    </Box>
    <Box w="full" boxShadow="md" borderRadius="xl" p={4} mb={6}>
      <Text>Du wurdest vom Administrator gesperrt.</Text>
      <Button
        as={Link}
        target="_blank"
        mt={3}
        colorScheme="brand"
        href={config.contactUrl}
      >
        Hier liegt ein Missverständnis vor
      </Button>
    </Box>
  </PageContainer>
);
